import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-profile-picture-prompt',
  templateUrl: './profile-picture-prompt.html',
  styleUrls: ['./profile-picture-prompt.scss']
})
export class ProfilePicturePromptComponent implements OnInit {
  constructor(
    private dialogRef: MatDialogRef<ProfilePicturePromptComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {}

  practitionerNames: any;

  ngOnInit(): void {
    this.practitionerNames = this.data?.practitioners;
  }

  onSkip() {
    this.dialogRef.close('skip');
  }
  onUpload() {
    this.dialogRef.close('upload');
  }
}
